import { createReducer } from 'redux-act'
import u from 'updeep'

import { read, update, clear, receive } from 'actions/gift-card'
import { switchLocale } from 'actions/ui'

const initialState = {
  id: '',
  step: 'gift-card',
  data: {
    phone: '',
    code: '',
    email: '',
    first_name: '',
    last_name: '',
    amount: 0,
    language: '',
    ui_language: '',
    note: '',
  },
  title: '',
  description: '',
  type: '',
  amounts: [],
}

export default createReducer({
  [read]: (state, payload) => {
    return u(payload, state)
  },
  [clear]: () => initialState,
  [update]: (state, payload) => {
    return u(payload, state)
  },
  [receive]: (state, payload) => {
    const data = payload.response
    return u({ data }, state)
  },
  [switchLocale]: (state, { locale }) => {
    return u({ data: { ui_language: locale } }, state)
  },
}, initialState)
